// extracted by mini-css-extract-plugin
export var actions = "_4m-0";
export var actionsContainer = "_4m-6";
export var border = "_4m-1";
export var childFullHeight = "_4m-d";
export var collapse = "_4m-2";
export var content = "_4m-8";
export var contentChild = "_4m-c";
export var fullscreen = "_4m-a";
export var headerContainer = "_4m-3";
export var headerRow = "_4m-5";
export var hidePadding = "_4m-9";
export var noScrollX = "_4m-e";
export var noScrollY = "_4m-f";
export var optOutTopPadding = "_4m-b";
export var pagePadding = "_4m-7";
export var profile = "_4m-g";
export var profileContainer = "_4m-h";
export var profileImage = "_4m-i";
export var profileMain = "_4m-j";
export var profileSubtitle = "_4m-l";
export var profileTitle = "_4m-k";
export var tabsWrapper = "_4m-4";
export var title = "_4m-m";